import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-header',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-header.component.html',
  styleUrl: './skeleton-header.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonHeaderComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
}
